import Payment from 'payment';

function clearNumber(value = '') {
  return value.replace(/\D+/g, '');
}

export function formatCreditCardNumber(value) {
  if (!value) {
    return value;
  }

  const issuer = Payment.fns.cardType(value);
  const clearValue = clearNumber(value);
  let nextValue;

  switch (issuer) {
    case 'amex':
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        10,
      )} ${clearValue.slice(10, 15)}`;
      break;
    case 'dinersclub':
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        10,
      )} ${clearValue.slice(10, 14)}`;
      break;
    default:
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
        4,
        8,
      )} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 19)}`;
      break;
  }

  return nextValue.trim();
}

export function formatCVC(value, prevValue, allValues = {}) {
  const clearValue = clearNumber(value);
  let maxLength = 4;

  if (allValues.number) {
    const issuer = Payment.fns.cardType(allValues.number);
    maxLength = issuer === 'amex' ? 4 : 3;
  }

  return clearValue.slice(0, maxLength);
}

export function formatExpirationDate(value) {
  const clearValue = clearNumber(value);

  if (clearValue.length >= 3) {
    return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 4)}`;
  }

  return clearValue;
}

export function formatFormData(data) {
  return Object.keys(data).map(d => `${d}: ${data[d]}`);
}

export function GetCreditCardBrand(CreditCardNumber) {
  var jcb_regex = new RegExp('^(?:2131|1800|35)[0-9]{0,}$');
  var amex_regex = new RegExp('^3[47][0-9]{0,}$');
  var diners_regex = new RegExp('^3(?:0[0-59]{1}|[689])[0-9]{0,}$');
  var visa_regex = new RegExp('^4[0-9]{0,}$');
  var mastercard_regex = new RegExp('^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]{0,}$');
  var maestro_regex = new RegExp('^(5[06789]|6)[0-9]{0,}$');
  var discover_regex = new RegExp('^(6011|65|64[4-9]|62212[6-9]|6221[3-9]|622[2-8]|6229[01]|62292[0-5])[0-9]{0,}$');

  var re = {
      "credit card": /^(4026|417500|4405|4508|4844|4913|4917)\d+$/, //electron
      "credit card": maestro_regex, // /^(5018|5020|5038|5612|5893|6304|6759|6761|6762|6763|0604|6390)\d+$/, //maestro
      "credit card": /^(5019)\d+$/, //dankort
      "credit card": /^(636)\d+$/, //interpayment
      "credit card": /^(62|88)\d+$/, //unionpay
      "visa": visa_regex, // /^4[0-9]{12}(?:[0-9]{3})?$/,
      "mastercard": mastercard_regex, /// /^5[1-5][0-9]{14}$/,
      "amex": amex_regex, // /^3[47][0-9]{13}$/,
      "diners club": diners_regex, // /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
      "discover": discover_regex, // /^6(?:011|5[0-9]{2})[0-9]{12}$/,
      "jcb": jcb_regex, // /^(?:2131|1800|35\d{3})\d{11}$/
  };

  CreditCardNumber = CreditCardNumber.replace(/\D/g, '');

  for (var key in re) {
      if (re[key].test(CreditCardNumber)) {
          return key
      }
  }

  return "credit card";
};

export function GetCreditCardVality(CreditCardNumber) {
  var sum = 0;
  for (var i = 0; i < CreditCardNumber.length; i++) {
      var intVal = parseInt(CreditCardNumber.substr(i, 1));
      if (i % 2 == 0) {
          intVal *= 2;
          if (intVal > 9) {
              intVal = 1 + (intVal % 10);
          }
      }
      sum += intVal;
  }
  return (sum % 10) === 0;
};
